import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appEmailLowercase]',
  standalone: false
})
export class EmailLowercaseDirective {
  constructor(private el: ElementRef) {}

  @HostListener('ionInput', ['$event'])
  onIonInput(event: CustomEvent) {
    this.convertToLowercase(event);
  }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    this.convertToLowercase(event);
  }

  @HostListener('ionBlur', ['$event'])
  onIonBlur(event: CustomEvent) {
    this.convertToLowercase(event);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    this.convertToLowercase(event);
  }

  private convertToLowercase(event: any) {
    let input: HTMLInputElement | null = null;
    
    // Handle different event types
    if (event.target) {
      if (event.target.tagName === 'ION-INPUT') {
        // For ion-input, get the actual input element inside
        const ionInputElement = event.target as any;
        
        // Try different methods to get the actual input
        input = ionInputElement.querySelector('input') || 
                ionInputElement.getInputElement?.() || 
                ionInputElement.shadowRoot?.querySelector('input');
                
      } else if (event.target.tagName === 'INPUT') {
        input = event.target as HTMLInputElement;
      }
    }

    if (input && input.value && input.value !== input.value.toLowerCase()) {
      const originalValue = input.value;
      input.value = input.value.toLowerCase();
      
      // Trigger change event to update form control
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } 
  }
}